export default __webpack_public_path__ + "static/media/LILY CARTER.b515f5ee.jpg";